import React, { Component } from 'react';
import { Col, Row } from "antd";
import '../components-style.css';

//Tension img
import bloodPressure_grey from '../../Images/BloodPressure/BloodPressure_grey.png';
import bloodPressure_green from '../../Images/BloodPressure/BloodPressure_green.png';
import bloodPressure_orange from '../../Images/BloodPressure/BloodPressure_orange.png';
import bloodPressure_red from '../../Images/BloodPressure/BloodPressure_red.png';

class tensionDisplay extends Component {

    //Function to display SpO2 alert logo with the good color
    getSpO2Img(){

        if(this.props.tensionDisplay.color === "#21BA45"){
            //return green
            return (<img src={bloodPressure_green} style={{ height: "auto", maxHeight: "100%", width: "auto", maxWidth: "55px"}} alt="SPO2_logo"/>)
        }
        else if(this.props.tensionDisplay.color === "#F2711C"){
            //return orange
            return (<img src={bloodPressure_orange} style={{ height: "auto", maxHeight: "100%", width: "auto", maxWidth: "55px"}} alt="SPO2_logo"/>)
        }
        else if(this.props.tensionDisplay.color === "#DB2828"){
            //return red
            return (<img src={bloodPressure_red} style={{ height: "auto", maxHeight: "100%", width: "auto", maxWidth: "55px"}} alt="SPO2_logo"/>)
        }
        else if(this.props.tensionDisplay.color === "#5E8FF7"){
            //return blue
            return (<img src={bloodPressure_red} style={{ height: "auto", maxHeight: "100%", width: "auto", maxWidth: "55px"}} alt="SPO2_logo"/>)
        }
        else{
            //return grey
            return (<img src={bloodPressure_grey} style={{ height: "auto", maxHeight: "100%", width: "auto", maxWidth: "55px"}} alt="SPO2_logo"/>)
        }
    }

    display_value(){

        let unit = ""
        if (this.props.tensionDisplay.systolic !== "-"){
            unit = "mmHg"
        }

        return(
            <Row style={{ flex:1, flexDirection:'row', alignItems:'center', justifyContent:'center', paddingTop:"5%", paddingBottom:"5%"}}>
                {
                    this.getSpO2Img()
                }
                <Row>                    
                    <div style={{color: this.props.tensionDisplay.color}}>
                        <div id="row-measure-style">{this.props.tensionDisplay.systolic}/{this.props.tensionDisplay.diastolic}</div>
                        <div id="row-unit-style">{unit}</div>                        
                    </div>                    
                </Row>
            </Row>
        )
    }

    //Display render
   	render(){

        return (
            <div>
                {(this.props.alert) ?
                    <Col style={{backgroundColor: "yellow"}}>
                        {this.display_value()}
                    </Col>
                    :
                    <Col>
                        {this.display_value()}
                    </Col>              
                }
            </div>
        );
   	}
}
export default (tensionDisplay);